import type {
  DepartmentReportDto,
  EmployeeReportDto,
  ManagerDashboardDto,
} from '@ledokol/contracts'
import { api } from './client'

export async function fetchManagerDashboard(
  departmentId: string | undefined,
  from: string,
  to: string,
): Promise<ManagerDashboardDto> {
  const r = await api.get<ManagerDashboardDto>('/dashboard', {
    params: { from, to, ...(departmentId ? { department_id: departmentId } : {}) },
  })
  return r.data
}

export async function fetchDepartmentReport(
  id: string,
  from: string,
  to: string,
): Promise<DepartmentReportDto> {
  const r = await api.get<DepartmentReportDto>(`/reports/department/${id}`, { params: { from, to } })
  return r.data
}

export async function fetchEmployeeReport(
  id: string,
  from: string,
  to: string,
): Promise<EmployeeReportDto> {
  const r = await api.get<EmployeeReportDto>(`/reports/employee/${id}`, { params: { from, to } })
  return r.data
}
